import { render, staticRenderFns } from "./AdditionalCoordinates.vue?vue&type=template&id=45e93ad4&scoped=true"
import script from "./AdditionalCoordinates.vue?vue&type=script&lang=js"
export * from "./AdditionalCoordinates.vue?vue&type=script&lang=js"
import style0 from "./AdditionalCoordinates.vue?vue&type=style&index=0&id=45e93ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e93ad4",
  null
  
)

export default component.exports